import React from 'react';
import clockOutline from "../../../assets/images/clock-outline.svg";
import starList from "../../../assets/images/list-stars-outline.svg";
import cefLogo from "../../../assets/images/cef_logo.svg";
export var CEF_Clock = function CEF_Clock() {
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: clockOutline
  });
};
export var CEF_Star_List = function CEF_Star_List() {
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: starList
  });
};
export var HeaderImg = function HeaderImg(props) {
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: props.className,
    src: cefLogo
  });
};